// extracted by mini-css-extract-plugin
export default {"header":"Header_header__YMs9O","main-image":"Header_main-image__qT8t1"};